<template>
    <div class="about-area ptb-100">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12" data-aos="fade-right">
                    <div class="about-content">
                        <span class="sub-title">Über uns</span>
                        <h2>Bringen Sie Ihr Unternehmen auf das nächste Level</h2>
                        <p>Benovium e.U. wurde mit einer klaren Vision gegründet: Hochwertige Webentwicklung, die für jedes Unternehmen zugänglich ist. Wir verstehen die Herausforderungen kleiner und mittelständischer Betriebe und bieten maßgeschneiderte digitale Lösungen ohne Agentur-Overhead.</p>
                        <p>Mit über 8 Jahren Erfahrung in der Softwareentwicklung wissen wir, worauf es ankommt. Keine unnötigen Meetings, keine aufgeblähten Prozesse – stattdessen direkte Kommunikation und schnelle Ergebnisse.</p>
                        <p>Bei uns haben Sie einen persönlichen Ansprechpartner, der Ihr Projekt von Anfang bis Ende begleitet. Wir arbeiten eng mit Ihnen zusammen, um Ihre individuellen Anforderungen zu verstehen und optimal umzusetzen.</p>
                    </div>
                </div>

                <div class="col-lg-6 col-md-12" data-aos="fade-left" data-aos-delay="200">
                    <div class="about-image">
                        <img src="../../assets/img/about-img.jpg" alt="image">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TakeYourBusiness'
}
</script>